
function isScrolledIntoView(elem){
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop)); 
}




// Scroll event listener
if(document.querySelector('.animate')){
  window.addEventListener('scroll', function() {
    const elements = document.querySelectorAll('.animate');
    elements.forEach(function(el) {
      if (isScrolledIntoView(el)) {
        el.classList.add('animated');
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {


  if(document.querySelector('.animate')){
    document.querySelectorAll('.animate').forEach(function(el) {
      if (isScrolledIntoView(el)) {
        el.classList.add('animated');
      }
    });
  }


  const logoFooter = document.querySelector('.logo_footer');

  if (logoFooter) {
    logoFooter.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default action if it's a link
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Smooth scrolling
      });
    });
  }

  if(document.querySelector('.text-block')){

    var textBlocks = $(".text-block");
    var imageBlocks = $(".image-block");
    var sticky = $(".sticky-inner");
    var section = $(".scroll-section");

    function updateActiveBlock() {
      var scrollPos = $(window).scrollTop();
      var windowHeight = $(window).height();

      var currentIndex = 0;

      // Determine which block is active
      textBlocks.each(function(index) {
        var blockTop = $(this).offset().top - 200; // adjust offset if needed
        if (scrollPos + windowHeight / 2 >= blockTop) {
          currentIndex = index;
        }
      });

      // Activate left text
      textBlocks.removeClass("active");
      $(textBlocks[currentIndex]).addClass("active");

      // Activate corresponding right image
      var targetImageId = $(textBlocks[currentIndex]).data("image");
      imageBlocks.removeClass("active");
      $("#" + targetImageId).addClass("active");

      // Sticky logic for right image
      var lastBlock = textBlocks.last();
      var lastBlockTop = lastBlock.offset().top;

      if (scrollPos + windowHeight >= lastBlockTop + lastBlock.outerHeight()) {
        // Last block reached → right image scrolls normally
        sticky.css({ position: 'relative', top: 'auto' });
      } else {
        // Sticky for other blocks
        sticky.css({ position: 'sticky', top: 100 });
      }
    }

    // Trigger on scroll & resize
    $(window).on("scroll resize", updateActiveBlock);

    // Initial trigger on page load
    updateActiveBlock();
  }


  if(document.getElementById('play-icon-overlay')){
    document.querySelectorAll('.play-icon-overlay').forEach(function(playBtn) {
    playBtn.addEventListener('click', function() {
      const container = playBtn.closest('.video-container');
      const videoElement = container.querySelector('video');
      const iframeElement = container.querySelector('iframe');

      // If it's a hosted video
      if (videoElement) {
        videoElement.play();
        playBtn.style.display = 'none'; // Hide the play icon
      }

      // If it's an iframe (YouTube or Vimeo)
      if (iframeElement) {
        const iframeSrc = iframeElement.getAttribute('data-src');
        iframeElement.setAttribute('src', iframeSrc + '&autoplay=1&mute=1');
        playBtn.style.display = 'none'; // Hide the play icon
      }
    });
    });


  }

  if(document.querySelector(".sticky-atc-bar")){
    const stickyBar = document.querySelector(".sticky-atc-bar");
    const buyBox = document.querySelector(".product-form"); // main add-to-cart form area

    if (!stickyBar || !buyBox) return;

    const showStickyBar = () => stickyBar.classList.add("active");
    const hideStickyBar = () => stickyBar.classList.remove("active");

    window.addEventListener("scroll", function () {
      const rect = buyBox.getBoundingClientRect();

      // Check if buy box is out of view (below the screen)
      if (rect.bottom < 0) {
        showStickyBar();
      } else {
        hideStickyBar();
      }
    });

    // Sticky ATC button triggers real Shopify add-to-cart button
    const stickyButton = document.querySelector(".sticky-atc-btn");
    stickyButton?.addEventListener("click", function () {
      const realATC = document.querySelector("form[action*='/cart/add'] [type='submit']");
      if (realATC) {
        realATC.click();
      }
    });
  }
});


